import { Preview } from "components/PreviewModal";
import { usePageTitle } from "hooks/usePageTitle";
import { useHistory, useParams } from "react-router-dom";
import { useGetFolderOrFileQuery } from "store/apis/previewUrl";

export default function SharedFilePreview() {
  usePageTitle("File Preview");
  const history = useHistory();
  const { docId, groupId } = useParams<{ docId: string; groupId: string }>();

  const { data: file } = useGetFolderOrFileQuery(
    { groupId: groupId, fileId: docId },
    { skip: !Boolean(docId) || !groupId }
  );

  const onClose = () => {
    const parentFolderUrl = `/docs/${groupId}/${file?.parent_uuid}`;
    history.push(parentFolderUrl);
  };

  return (
    <Preview
      showModal={true}
      closeModal={onClose}
      previewId={docId}
      groupId={groupId}
    />
  );
}
